import { Mapper } from './mapper';

export const IndicativoAdmissao = Mapper.from([
  [1, 'Normal'],
  [2, 'Decorrente de ação fiscal'],
  [3, 'Decorrente de decisão judicial'],
]);
